import injectSheet from 'react-jss';

import Splash from './component';
import styles from './styles';

export default injectSheet(styles)(Splash);
